import type { dynamicSidebarHeaderTab } from '@/components/Modals/Sidebar/hooks/useDynamicSidebarHeader';

// Just uses default tabs
export const UpgradePlanTabs: dynamicSidebarHeaderTab[] = [];